module.exports = __webpack_public_path__ + "static/img/cangzhou.311d87f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/cangzhou.jpg
// module id = Axod
// module chunks = 6